@if(breadcrumbs().length){<q-breadcrumbs></q-breadcrumbs>}
<div class="container my-4 quote-module">
    <router-outlet></router-outlet>
</div>